import React from 'react';

import { Skeleton } from '@material-ui/lab';

import Slider from '../../../Slider';

import { SliderWithControlSkeletonProps } from './SliderWithControlSkeleton.types';

const SliderWithControlSkeleton: React.FC<SliderWithControlSkeletonProps> = ({ className }) => {
  return (
    <div
      className={`flex flex-column flex-justify-center flex-center ${className}`}
    >
      <Skeleton variant="rect" width={150} height={30} className="br16" />
      <Slider className="mt3 width-100 border-box" />
    </div>
  );
};

export default SliderWithControlSkeleton;
export { SliderWithControlSkeletonProps };
